export enum DataSeriesRelations {
  IS_PREVIOUS_REVISION_OF = 'IS_PREVIOUS_REVISION_OF',
  HAS_PREVIOUS_REVISED_BY = 'HAS_PREVIOUS_REVISED_BY',
}

export interface DataSeriesRelation {
  relation: string;
  target: number;
}
